exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".redo-button{position:absolute;top:143px;left:142px;background-color:#000;color:#ddd;font-size:22px;padding:5px 9px}.redo-button i{min-width:1em}@media (min-width:700px){.redo-button{top:282px;left:282px;padding:15px 20px;font-size:42px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./styles/modules/redo.scss
// module id = 303
// module chunks = 0